<template>
  <v-app id="app">
    <mySidebar />

    <v-content>
      <myHeader />

      <v-container fill-height id="mainLayout">
        <v-layout>
          <v-flex>
            <v-alert
              class="mb-3 py-2"
              transition="scale-transition"
              dismissible
              v-model="alert"
              :color="this.$store.getters['master/alert'].type"
              :type="this.$store.getters['master/alert'].type"
              outlined
              >{{ this.$store.getters["master/alert"].message }}</v-alert
            >

            <router-view />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <notificationBar />
  </v-app>
</template>

<script>
import myHeader from "../../themes/partials/Header.vue"
import mySidebar from "../../themes/partials/Sidebar.vue"
import myFooter from "../../themes/partials/Footer.vue"
import notificationBar from "@/modules/notifications/partials/NotificationBar.vue"

export default {
  name: "main-layout",

  components: {
    myHeader,
    mySidebar,
    myFooter,
    notificationBar
  },

  computed: {
    alert: {
      get() {
        return this.$store.getters["master/alert"].show
      },
      set() {
        this.$globalMessages("", "", false)
        return false
      }
    }
  }
}
</script>
